import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, Divider, IconButton } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeftSharp';
import ChevronRightIcon from '@material-ui/icons/ChevronRightSharp';

const drawerWidth = 240;
const styles = (theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        zIndex: 10,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        zIndex: 10,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        paddingTop: '102px',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        'background-color': theme.palette.fifth.backgroundColor,
    },
    drawerClose: {
        zIndex: 10,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        paddingTop: '48px',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing.unit * 7 + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing.unit * 9 + 1,
        },
        'background-color': theme.palette.fifth.backgroundColor,
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    toolbarCollapsed: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'center',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 3,
    },
    navLink: {
        display: 'flex',
        textDecoration: 'none',
        '&:hover': {
            'background-color': '#1B4064',
            '& > div > div > span > span': {
                color: '#FFFFFF',
            },
        },
    },
    navLinkActive: {
        'background-color': '#1B4064',
        '& > div > div > span > span': {
            color: '#FFFFFF',
        },
    },
    center: {
        display: 'inline-flex',
        'align-items': 'center',
        color: '#aaa',
    },
});
const DetailWrapper = ({ classes, navLinks, children }) => {
    const [isOpened, setIsOpened] = useState(window.innerWidth >= 960);

    return (
        <div className={classes.root}>
            <Drawer
                id="yeself-drawer"
                anchor="left"
                variant="permanent"
                className={`${classes.drawer} ${isOpened ? classes.drawerOpen : classes.drawerClose}`}
                classes={{
                    paper: isOpened ? classes.drawerOpen : classes.drawerClose,
                }}
                open={isOpened}
            >
                <List>
                    {navLinks.map((item) => {
                        if (item.isRedirect) {
                            return (
                                <a
                                    id="yeself-detail-wrapper-navlink"
                                    key={`analytic-sidebar-navlink-item-${item.displayName}`}
                                    className={classes.navLink}
                                    href={item.navLinkTo}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <ListItem key={`analytic-sidebar-item-${item.displayName}`} button>
                                        <ListItemText
                                            open={isOpened}
                                            primary={
                                                <span className={classes.center}>
                                                    {item.icon}
                                                    {isOpened && <span>{item.displayName}</span>}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                </a>
                            );
                        }

                        return (
                            <NavLink
                                id="yeself-detail-wrapper-navlink"
                                key={`application-sidebar-navlink-item-${item.displayName}`}
                                className={classes.navLink}
                                to={item.navLinkTo}
                                activeClassName={classes.navLinkActive}
                            >
                                <ListItem key={`analytic-sidebar-item-${item.displayName}`} button>
                                    <ListItemText
                                        open={isOpened}
                                        primary={
                                            <span className={classes.center}>
                                                {item.icon}
                                                {isOpened && <span>{item.displayName}</span>}
                                            </span>
                                        }
                                    />
                                </ListItem>
                            </NavLink>
                        );
                    })}
                </List>
                <div className={isOpened ? classes.toolbar : classes.toolbarCollapsed}>
                    <IconButton style={{ color: '#aaa' }} onClick={() => setIsOpened(!isOpened)}>
                        {isOpened ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
            </Drawer>
            <main className={classes.content}>{children}</main>
        </div>
    );
};

export default withStyles(styles)(DetailWrapper);
